import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

// Renderiza markdown (negrita, listas, saltos) con el look de Olimpo.
export default function Markdown({ children = "", className = "" }) {
  return (
    <div className={`md-olimpo ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ node, ...p }) => <p className="mb-1.5 last:mb-0 leading-relaxed" {...p} />,
          strong: ({ node, ...p }) => <strong className="text-dorado font-semibold" {...p} />,
          em: ({ node, ...p }) => <em {...p} />,
          ul: ({ node, ...p }) => <ul className="list-disc pl-5 mb-2 space-y-1" {...p} />,
          ol: ({ node, ...p }) => <ol className="list-decimal pl-5 mb-2 space-y-1" {...p} />,
          li: ({ node, ...p }) => <li className="leading-relaxed" {...p} />,
          h1: ({ node, ...p }) => <h3 className="titulo text-lg mb-2" {...p} />,
          h2: ({ node, ...p }) => <h4 className="mono-label text-dorado mb-2" {...p} />,
          h3: ({ node, ...p }) => <h4 className="mono-label text-dorado mb-2" {...p} />,
          a: ({ node, ...p }) => <a className="text-dorado underline" target="_blank" rel="noreferrer" {...p} />,
          code: ({ node, inline, ...p }) =>
            inline ? (
              <code className="px-1 py-0.5 rounded bg-negro2 text-dorado text-[0.85em]" {...p} />
            ) : (
              <code className="block p-3 rounded-lg bg-negro2 text-crema text-[0.85em] overflow-x-auto my-2" {...p} />
            ),
          blockquote: ({ node, ...p }) => <blockquote className="border-l-2 border-dorado/50 pl-3 text-gris my-2" {...p} />,
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
